import React from 'react';
import { FadeIn } from './FadeIn';
export function MethodTimeline() {
  const weeks = [{
    week: 'Semana 1',
    title: 'Reinicio',
    desc: 'Tu único objetivo será empezar. No busques perfección, buscá consistencia. Tomar más agua, comer proteína, usar la Airfryer.',
    color: 'border-amber-200 bg-amber-50'
  }, {
    week: 'Semana 2',
    title: 'Consolidación',
    desc: 'Mejoramos la calidad de las elecciones. Comer más despacio, reducir ultraprocesados y planificar las comidas del día siguiente.',
    color: 'border-brand-200 bg-brand-50'
  }, {
    week: 'Semana 3',
    title: 'Automatización',
    desc: 'Dejamos de depender de la motivación. Cocinar por adelantado, tener opciones saludables disponibles y evitar decisiones impulsivas.',
    color: 'border-emerald-200 bg-emerald-50'
  }, {
    week: 'Semana 4',
    title: 'Transformación',
    desc: 'Más energía, menos antojos, mayor control. Pensamos a largo plazo para que tus hábitos no terminen cuando acabe el programa.',
    color: 'border-blue-200 bg-blue-50'
  }];
  return <section className="py-24 bg-stone-50" data-id="element-161">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-162">
        <FadeIn data-id="element-163">
          <div className="text-center mb-16" data-id="element-164">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-stone-900 mb-4" data-id="element-165">
              El Mapa de 30 Días
            </h2>
            <p className="text-lg text-stone-600" data-id="element-166">
              Un paso a paso claro para transformar tu alimentación sin
              agobiarte.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-stone-200 before:to-transparent" data-id="element-167">
          {weeks.map((week, i) => <FadeIn key={i} delay={i * 0.1} direction={i % 2 === 0 ? 'right' : 'left'} data-id="element-168">
              <div className={`relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active`} data-id="element-169">
                {/* Timeline dot */}
                <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-brand-500 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10 font-bold font-heading" data-id="element-170">
                  {i + 1}
                </div>

                {/* Card */}
                <div className={`w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 rounded-2xl border-2 ${week.color} shadow-sm`} data-id="element-171">
                  <div className="text-sm font-bold text-brand-600 uppercase tracking-wider mb-1" data-id="element-172">
                    {week.week}
                  </div>
                  <h3 className="text-xl font-heading font-bold text-stone-900 mb-2" data-id="element-173">
                    {week.title}
                  </h3>
                  <p className="text-stone-600 text-sm leading-relaxed" data-id="element-174">
                    {week.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}